import { PoliciesAddDetailChecksPage } from "~/pages/shared/policy/PoliciesAddDetailChecksPage";

export function OrganizationPoliciesAddDetailChecksPage() {
  return <PoliciesAddDetailChecksPage basePath="/organization/policies" />;
}
